import { gql } from '@apollo/client';

export default gql`
  mutation captureAdvancedPassengerInformation(
    $bookingReference: String!
    $passengerUUID: String!
    $passengerID: String
    $guardianUUID: String
    $dateOfBirth: String!
    $documentNumber: String!
    $familyName: String!
    $givenName: String!
    $gender: String!
    $nationality: String!
    $documentType: String!
    $countryOfIssue: String!
    $expiryDate: String!
  ) {
    captureAdvancedPassengerInformation(
      bookingReference: $bookingReference
      passengerUUID: $passengerUUID
      passengerID: $passengerID
      guardianUUID: $guardianUUID
      dateOfBirth: $dateOfBirth
      documentNumber: $documentNumber
      familyName: $familyName
      givenName: $givenName
      gender: $gender
      nationality: $nationality
      documentType: $documentType
      countryOfIssue: $countryOfIssue
      expiryDate: $expiryDate
      platform: "Voyager"
    )
  }
`;
